import { IBaseAllergy } from '../../../interfaces';
import { BaseMedicalConditionToMedicalHistoryHandler } from '../../../mappings/medical-condition-to-medical-history';
import {
  CorePracticePatientMedicalConditionOption,
  ICorePracticePatientMedicalConditionOption,
  PatientMedicalConditionOptionSourceEntity,
} from '../../source/entities/patient-medical-condition-options';

export class CorePracticeMedicalConditionMappingHandler extends BaseMedicalConditionToMedicalHistoryHandler<
  CorePracticePatientMedicalConditionOption,
  PatientMedicalConditionOptionSourceEntity
> {
  sourceEntity = new PatientMedicalConditionOptionSourceEntity();
  translateFn = (
    record: ICorePracticePatientMedicalConditionOption
  ): IBaseAllergy => ({
    description: record.description,
    id: record.description,
  });
}
